import React from "react";
import styled from "styled-components";
import { Link, useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import SearchIcon from "@material-ui/icons/Search";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

import { formatDay } from "../Issues/dates";

/**
 * The page's address, the ways to open its Monitored URI page and the page on the site, when it was last
 * checked, and the way back to Issues as the reader left it; `controls`, the chart's zoom, on the right.
 */
export default function Header({ page, issuesRoute, pageRoute, controls }) {
    const history = useHistory();
    const fromIssues = useSelector((state) => state.issueDeepDive.fromIssues);
    // Back returns to the Issues list the deep dive was opened from, with its filters, when it was this workspace's.
    const back = () => history.push(fromIssues?.location.pathname === issuesRoute ? fromIssues.location : issuesRoute);
    return (
        <Wrap>
            <Identity>
                <Back type="button" onClick={back}><ArrowBackIcon style={{ fontSize: "0.9rem" }} /> Issues</Back>
                <AddressLine>
                    <AddressBar>
                        <AddressText title={page.uri}>{page.uri}</AddressText>
                    </AddressBar>
                    <ExternalLink as={Link} to={pageRoute} title="View in SEO tool">
                        <SearchIcon style={{ fontSize: "0.9rem" }} />
                    </ExternalLink>
                    <ExternalLink href={page.uri} target="_blank" rel="noopener noreferrer" title="Open in new tab">
                        <OpenInNewIcon style={{ fontSize: "0.9rem" }} />
                    </ExternalLink>
                </AddressLine>
                {page.lastChecked && <Checked>checked {formatDay(page.lastChecked)}</Checked>}
            </Identity>
            {controls}
        </Wrap>
    );
}

const Wrap = styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 14px;
    @media (max-width: 900px) { flex-direction: column; align-items: stretch; }
    @media (max-width: 600px) { padding: 0 16px; }
`;

const Identity = styled.div`
    flex: 1;
    min-width: 0;
`;

const Back = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 0;
    margin-bottom: 8px;
    border: none;
    background: none;
    color: #6366f1;
    font-size: 0.74rem;
    font-weight: 600;
    cursor: pointer;
    &:hover { text-decoration: underline; }
`;

const AddressLine = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    min-width: 0;
`;

const AddressBar = styled.h1`
    display: flex;
    flex: 1;
    min-width: 0;
    margin: 0;
    background: #f1f5f9;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 6px 10px;
`;

const AddressText = styled.span`
    min-width: 0;
    font-size: 1rem;
    font-weight: 700;
    line-height: 1.5;
    color: #0f172a;
    word-break: break-all;
`;

const ExternalLink = styled.a`
    display: inline-flex;
    flex-shrink: 0;
    color: #cbd5e1;
    text-decoration: none;
    transition: color 120ms;
    &:hover { color: #6366f1; }
`;

const Checked = styled.div`
    margin-top: 4px;
    font-size: 0.78rem;
    color: #64748b;
`;
